const DEFAULT_SLIDER_SETTINGS = {
    slidesToShow: 3.25,
    slidesToScroll: 3,
    arrows: true,
    dots: false,
}

export const SLIDER_SETTINGS = {
    ...DEFAULT_SLIDER_SETTINGS,
    accessibility: false,
    slidesToShow: 4.25,
    rows: 2,
    lazyLoad: false,
    adaptiveHeight: false,
    infinite: false,
    focusOnSelect: false,
    responsive: [
        {
            breakpoint: 576,
            settings: {
                ...DEFAULT_SLIDER_SETTINGS,
                variableWidth: false
            }
        },
        {
            breakpoint: 768,
            settings: {
                ...DEFAULT_SLIDER_SETTINGS,
                variableWidth: false
            }
        },
        {
            breakpoint: 992,
            settings: {
                ...DEFAULT_SLIDER_SETTINGS,
                variableWidth: false
            }
        }
    ]
}